export * from './alpha.validator';
export * from './alphaNumeric.validator';
export * from './compare.validator';
export * from './contains.validator';
export * from './email.validator';
export * from './hexcolor.validator';
export * from './lowercase.validator';
export * from './maxDate.validator';
export * from './maxNumber.validator';
export * from './minDate.validator';
export * from './minNumber.validator';
export * from './uppercase.validator';
export * from './range.validator';
export * from './custom.validator';
export * from './customChange.validator';
export * from './required.validator';


// WEBPACK FOOTER //
// ./node_modules/@rx/forms/validator/validators/rxvalidators.ts